import React from "react";
import Container from "react-bootstrap/Container";
import {Row} from "react-bootstrap";

interface Props{
    children: React.ReactNode,
    classes?: string,
    fluid?: boolean
}

export const DefaultContainer: React.FC<Props> = (props) => {
    return (
        <Container className={"body-container " + (props.classes ? props.classes : '')} fluid={props.fluid ?? false}>
            <Row>
                {props.children}
            </Row>
        </Container>
    )
}
